import styles from './layout.module.scss'
import { useNavigate } from 'react-router-dom'
import { ModalPP, ModalTerm } from '../components/modal'

export const MainFooter = () => {
	return (
		<div className={styles.mainFooter}>
			<div className={styles.containerBox}>
				<div className={styles.footerFirstRow}>
					<span className={styles.companyInfo}>
						<p style={{ fontSize: '12px' }}>
							경기도 성남시 분당구 대왕판교로 670, B동 1001호(삼평동, 유스페이스2)
							(주)스포이음 | 대표이사 : 민관홍 | 개인정보보호 책임자 : 현주영
						</p>
						<p style={{ fontSize: '12px' }}>
							사업자등록번호 : 112-87-01910 | 통신판매업 : 2023-성남분당A-0811호
						</p>
						<p style={{ fontSize: '12px' }}>
							Fax : 0504-323-6890 | E-Mail : master@spoeum.com
						</p>
						<p style={{ fontSize: '12px' }}>
							Copyright ©Spoeum. 2025. All rights reserved
						</p>
					</span>

					<span className={styles.footerIconBox}>
						<a
							href="https://www.instagram.com/spoeum_official"
							target="_blank"
							rel="noopener noreferrer">
							<img
								src={`/images/instagram-3.png`}
								alt="instagram"
								className={styles.footerIconInstagram}
								style={{ cursor: 'pointer' }}
							/>
						</a>
						<a
							href="https://www.facebook.com/profile.php?id=100063911509933"
							target="_blank"
							rel="noopener noreferrer">
							<img
								src={`/images/facebook-2.png`}
								alt="facebook"
								className={styles.footerIconFacebook}
								style={{ cursor: 'pointer' }}
							/>
						</a>
						<a
							href="https://www.facebook.com/profile.php?id=100063911509933"
							target="_blank"
							rel="noopener noreferrer">
							<span className={styles.btnGray}>회사소개</span>
						</a>
					</span>
				</div>
				<div className={styles.footerSecondRow}>
					<button
						type="button"
						className={styles.btnLink}
						data-bs-toggle="modal"
						data-bs-target="#termModal">
						<u className={styles.terms}>이용약관</u>
					</button>

					<button
						type="button"
						className={styles.btnLink}
						data-bs-toggle="modal"
						data-bs-target="#ppModal">
						<u className={styles.terms}>개인정보처리방침</u>
					</button>
				</div>
			</div>
			<ModalTerm />
			<ModalPP />
		</div>
	)
}
